// extracted by mini-css-extract-plugin
export default {"checkbox":"AbstractProductEditStep2_checkbox__7+eQK"};